const quotes = [

    {
        "quote": "A descoberta da verdade é evitada, não pela falsa aparência das coisas presentes e que induz ao erro, não diretamente pela fraqueza dos poderes de raciocínio, mas pela opinião preconcebida, pelo preconceito. ",
        "author": "Arthur Schopenhauer"
    },

    { "quote":"Descartes é justamente considerado como o pai da filosofia moderna, em geral, porque ajudou a faculdade da razão a andar com seus próprios pés, ao ensinar os homens a usarem seus cérebros, no lugar que anteriormente era ocupado pela Bíblia e Aristóteles. ",
    "author":"Arthur Schopenhauer"
    },
    { "quote":"Os primeiros quarenta anos de vida nos dão o texto; os próximos trinta fornecem o comentário sobre isso. ",
    "author": "Arthur Schopenhauer"},
    { "quote":"Fama é algo que deve ser ganho; honra, apenas algo que não deve ser perdido. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Nós perdemos três quartos de nós mesmos para sermos como as outras pessoas. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Os dois inimigos da felicidade humana são a dor e o tédio. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Os homens precisam de algum tipo de atividade externa, porque são inativos no seu interior. ",
    "author":"Arthur Schopenhauer"},

    { "quote":"O homem pode fazer o que ele quer, mas não pode querer o que ele quer. ",
    "author":"Arthur Schopenhauer"},

    { "quote":"Religião é a obra-prima da arte do adestramento animal, porque treina as pessoas sobre como elas devem pensar. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Quando você olha para trás em sua vida, parece que havia um complô, mas quando você está nela, é um desastre: há uma surpresa atrás da outra. Mais tarde, você vê que era perfeito. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"É a perda que nos ensina sobre o valor das coisas. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Jornalistas são como cachorros, quando alguma coisa se move eles começam a latir. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Um homem só pode ser ele mesmo enquanto estiver sozinho; e se ele não ama a solidão, ele não amará a liberdade; porque quando estamos sozinhos é que somos realmente livres. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"A descoberta da verdade é evitada, não pela falsa aparência das coisas presentes e que induz ao erro, não diretamente pela fraqueza dos poderes de raciocínio, mas pela opinião preconcebida, pelo preconceito. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Toda nação ridiculariza as outras nações e todas estão certas. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"As maiores realizações da mente humana são geralmente recebidas com desconfiança. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"É difícil encontrar a felicidade dentro de si mesmo, mas é impossível encontrá-la em qualquer outro lugar. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Quanto mais inteligente um homem é, menos misteriosa é a existência para ele. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"O intelecto é invisível para o homem que não tem nenhum. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"A riqueza é como a água do mar; quanto mais bebemos, mais sedentos nos tornamos. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"O mundo é minha ideia. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Esperar que um homem possa manter tudo o que, alguma vez já leu; é como esperar que leve no seu corpo tudo o que, alguma vez, comeu. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Todo homem leva os limites de seu próprio campo de visão para os limites do mundo. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"O ódio vem do coração; desprezo da cabeça; e nenhum sentimento está totalmente sob nosso controle. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Dificuldade é tentar ensinar a multidão que algo pode ser verdadeiro e falso ao mesmo tempo. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"A verdade não é uma prostituta que joga os braços ao redor do pescoço daquele que não a deseja; pelo contrário, ela é tão tímida que até o homem que sacrifica tudo para ela ainda não pode ter certeza de seus favores. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Só as religiões monoteístas fornecem o espetáculo de guerras religiosas, perseguições religiosas, tribunais heréticos, que destroem os ídolos e imagens dos deuses, que destroem templos indianos e colossos egípcios só porque um Deus ciumento havia dito: 'Não farás imagem de escultura'. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Ler é meramente um substituto para pensar por si mesmo; significa deixar alguém direcionar seus pensamentos. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"A compaixão pelos animais está intimamente ligada à bondade de caráter, e pode-se afirmar com segurança que quem é cruel com as criaturas vivas, não pode ser um bom homem. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"A vida é um negócio que não cobre os custos. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Viver só é o destino de todas as grandes almas. ",
    "author":"Arthur Schopenhauer"},

    { "quote":"Todas as religiões prometem uma recompensa além desta vida, na eternidade, através dos méritos de vontade ou coração, mas nenhuma recompensa para os méritos de sua cabeça, a compreensão. ",
    "author":"Arthur Schopenhauer"},

    { "quote":"Sem dúvida, quando a modéstia se tornou uma virtude, foi uma coisa muito vantajosa para os tolos, pois, se espera que todos falem de si como se fosse um deles. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"A pessoa que escreve para os tolos sempre têm certeza de um grande público. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Os anos finais da vida são como uma festa de máscaras, quando as máscaras são descartadas. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"A opinião é como um pêndulo e obedece à mesma lei. Se passar pelo centro de gravidade de um lado, ele deve ficar a uma distância semelhante do outro; e é só depois de um certo tempo que ele encontra o verdadeiro ponto em que pode permanecer em repouso. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Depois da sua morte, você será o que era antes do seu nascimento. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Compaixão é a base de toda a moralidade. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"O talento atinge um alvo que ninguém mais consegue acertar; O gênio acerta um alvo que ninguém mais pode ver. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"A natureza mostra que, com o crescimento da inteligência, vem a capacidade aumentada de dor, e é somente com o mais alto grau de inteligência que o sofrimento alcança seu ponto supremo. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Nos primeiros anos da juventude, ao contemplarmos a nossa próxima vida, somos como crianças num teatro antes de a cortina ser erguida, sentados de bom humor e aguardando ansiosamente que a peça comece. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Livrar um homem do erro não significa tirar algo dele, mas dar-lhe algo. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Toda verdade passa por três estágios. Primeiro, é ridicularizada. Em segundo lugar, é violentamente confrontada. Em terceiro lugar, é aceita como sendo óbvia. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"No nosso continente monogâmico, casar-se significa abdicar de metade dos direitos e duplicar os deveres. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Assim, a tarefa não é tanto ver o que ninguém ainda viu, mas pensar o que ninguém ainda pensou sobre o que todo mundo vê. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Toda criança é, de certo modo, um gênio; e todo gênio é de certo modo uma criança. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"O senso de humor é a única qualidade divina do homem. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Aquilo que somos contribui muito mais para a felicidade do que aquilo que temos ou representamos. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"Só a mudança é eterna, perpétua e imortal. ",
    "author":"Arthur Schopenhauer"},
    { "quote":"O fundamento sobre o qual repousa todo o nosso conhecimento e aprendizado é o inexplicável. ",
    "author":"Arthur Schopenhauer"}

]

export default quotes